import { mode, transparentize } from '@chakra-ui/theme-tools';
const getBaseStyle = (props) => {
    const { theme } = props;
    return {
        closeButton: {
            opacity: 1,
            _disabled: {
                cursor: 'not-allowed',
                color: mode(transparentize('black', 0.3)(theme), transparentize('white', 0.3)(theme))(props),
                opacity: 1,
                _hover: {
                    color: mode(transparentize('black', 0.3)(theme), transparentize('white', 0.3)(theme))(props),
                    opacity: 1,
                },
            },
            color: mode('white', 'black')(props),
        },
        container: {
            _hover: {
                _disabled: {
                    bg: mode(transparentize('gray.900', 0.1)(theme), transparentize('gray.0', 0.1)(theme))(props),
                },
            },
            _disabled: {
                cursor: 'not-allowed',
                bg: mode('gray.50', 'gray.800')(props),
                color: mode(transparentize('gray.900', 0.3)(theme), transparentize('gray.0', 0.3)(theme))(props),
            },
        },
    };
};
const getSolidStyle = (props) => {
    const { colorScheme, theme } = props;
    if (colorScheme === 'gray') {
        return {
            container: {
                borderRadius: 'full',
                bg: mode('gray.900', 'gray.0')(props),
                color: mode('gray.0', 'gray.900')(props),
                _hover: {
                    bg: mode('gray.800', 'gray.50')(props),
                },
                _active: {
                    bg: mode('gray.700', 'gray.100')(props),
                },
                _disabled: {
                    opacity: 1,
                    bg: mode(transparentize('gray.900', 0.1)(theme), transparentize('gray.0', 0.1)(theme))(props),
                    color: mode(transparentize('gray.900', 0.3)(theme), transparentize('gray.0', 0.3)(theme))(props),
                },
                _focusVisible: {
                    boxShadow: 'none',
                    outlineOffset: '2px',
                    outline: mode('1px solid black', '1px solid white')(props),
                },
            },
        };
    }
    return {
        container: {
            borderRadius: 'full',
            bg: mode(`${colorScheme}.500`, `${colorScheme}.300`)(props),
            color: mode('gray.0', 'gray.900')(props),
            _hover: {
                bg: mode(`${colorScheme}.600`, `${colorScheme}.200`)(props),
            },
            _active: {
                bg: mode(`${colorScheme}.700`, `${colorScheme}.100`)(props),
            },
            _disabled: {
                opacity: 1,
                bg: mode(transparentize('gray.900', 0.1)(theme), transparentize('gray.0', 0.1)(theme))(props),
                color: mode(transparentize('gray.900', 0.3)(theme), transparentize('gray.0', 0.3)(theme))(props),
            },
            _focusVisible: {
                boxShadow: 'none',
                outlineOffset: '2px',
                outline: mode(`1px solid ${transparentize(`${colorScheme}.600`, 1.0)(theme)}`, `1px solid ${transparentize(`${colorScheme}.200`, 1.0)(theme)}`)(props),
            },
        },
    };
};
const sizes = {
    sm: {
        container: {
            lineHeight: '1.5rem',
            fontSize: 'sm',
        },
        label: {
            lineHeight: '1.5rem',
        },
    },
    md: {
        container: {
            lineHeight: '1.5rem',
            py: 1,
            px: 3,
        },
        label: {
            lineHeight: '1.5rem',
        },
    },
};
const defaultProps = {
    size: 'md',
    variant: 'solid',
    colorScheme: 'gray',
};
const variants = {
    solid: getSolidStyle,
};
export default {
    baseStyle: getBaseStyle,
    sizes,
    defaultProps,
    variants,
};
//# sourceMappingURL=tag.js.map